import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import Link from "next/link";
import React from "react";
import { Settings } from "lucide-react";
import ThemeTabs from "../ThemeChooser";
import { cn } from "@/lib/utils";

export default function SettingMenu({ videoPage }: { videoPage: boolean }) {
  if (!videoPage) return null;

  return (
    <>
      <div className="h-full w-full flex items-center justify-center lg:hidden">
        <DropdownMenu>
          <DropdownMenuTrigger className="text-muted transition-colors hover:text-foreground">
            <Settings size={21} />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className={cn(
              "border-t-0 rounded-tr-none border-background rounded-tl-none p-3 pr-6",
              !videoPage && "mt-5 mr-4"
            )}
          >
            <DropdownMenuLabel>Appearance</DropdownMenuLabel>
            <DropdownMenuItem className="relative rounded-md">
              <ThemeTabs orientation="horizontal" />
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            {/* <DropdownMenuItem>Colours</DropdownMenuItem>
			  <DropdownMenuItem>Privacy</DropdownMenuItem> */}
            {/* <DropdownMenuLabel>My Account</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <Link href={"/users/login"}><DropdownMenuItem>Sign In</DropdownMenuItem></Link>
			  <Link href={"/users/create"}> <DropdownMenuItem>Create Blog</DropdownMenuItem>
			  </Link>  */}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>{" "}
      <div className="hidden lg:flex -right-3 -ml-3 relative ">
        <ThemeTabs orientation="horizontal" />
      </div>
    </>
  );
}
